import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { LoadingLine } from '@/components/ui/States';
import { StaffOnly } from '@/features/admin-content/StaffOnly';
import { useCan, useCurrentUser } from '@/features/admin-content/use-current-user';
import { PeopleDirectory } from '@/features/staff-workspace/PeopleDirectory';
import { authClient } from '@/lib/auth-client';

export const Route = createFileRoute('/admin/users')({
  component: AdminUsersPage,
});

function AdminUsersPage() {
  const navigate = useNavigate();
  const { data: session, isPending: sessionPending } = authClient.useSession();
  const meQuery = useCurrentUser();
  const allowed = useCan('users.admin');

  if (sessionPending || meQuery.isPending) {
    return <LoadingLine>Loading</LoadingLine>;
  }

  if (!session) {
    void navigate({ to: '/sign-in' });
    return null;
  }

  if (!allowed) {
    return (
      <StaffOnly
        title="You cannot manage people"
        description="Only an admin can grant or remove staff roles."
      />
    );
  }

  return (
    <div className="grid gap-6">
      <PageHeader
        eyebrow="Workspace"
        title="People"
        description="Search for a signed-up colleague, then grant Teacher or Admin."
      />
      <PeopleDirectory />
    </div>
  );
}
